import React from "react";
import BenefitsCard from "./BenefitsCard";
import styles from "../../styles/companyvision.module.css";
import righImage from "../../../assets/images/about_blue_section.webp";

const CompanyVision = () => {
  return (
    <div className={styles["vision-container"]}>
      <div className={styles["vision-content"]}>
        <div className={styles["title-container"]}>
          <h1 className={styles["vision-title"]}>
            <span className={styles["company-text"]}>会社</span>
            <span className={styles["vision-text-blue"]}>ビジョン</span>
            <span className={styles["mission-text"]}>& ミッション</span>
          </h1>
        </div>

        {/* <h2 className={styles["title"]}><strong>Here's Why you are going to love working with DG FutureTech</strong></h2> */}

        <div className={styles["yellow-line"]}></div>

        <p margin-right="40px" className={styles.description} align="justify" >
          私たちの理念は常に非常にシンプルです。最高レベルの技術的専門知識と優れた顧客サービスを組み合わせて、お客様の長期にわたる信頼できるパートナーとなることです。当社は企業として、価値中心のビジネスにつながる業務の最適化に向けて、共同創造と共同革新に熱心に取り組んでいます。
        </p>
        <br />
        <h2 className={styles.title}>
          <strong>私たちのビジョン</strong>
        </h2>
        <br />
        <p className={styles.description}>
          当社のビジョンは、お客様に競争上の優位性をもたらし、生産性を向上し、運用コストを削減するソリューションに重点を置くことで、マネージドサービスのハイエンドプロバイダーになることです。
        </p>
      </div>

      <div className={styles["desktop-section"]}>
        <div
          className={styles["desktop-image"]}
          style={{ backgroundImage: `url(${righImage})` }}
          loading="lazy"
        />
        <BenefitsCard />
      </div>

      <div className={styles["mobile-section"]}>
        <div className={styles["mobile-benefits-card"]}>
          <BenefitsCard />
        </div>
        <img
          src={righImage}
          alt="Company Vision"
          className={styles["mobile-image"]}
          loading="lazy"
          width="100%"
          height="auto"
        />
      </div>
    </div>
  );
};

export default CompanyVision;
